/**
 * Employment Type / Status / Role filters for the hiring capacity timeline (David, Sep 2026).
 * Reuses the ticketing views' checkbox-dropdown `MultiSelect` rather than a new local copy — it's
 * a generic, domain-agnostic fallback (the design system has no multi-value Select), and this file
 * already borrows across feature folders the same way (`CockpitTabs` from `./taCockpit`).
 */
import { MultiSelect } from '../../components/ticketing/MultiSelect';
import type { EmploymentType } from '../../services/internalPlaygroundApi';
import { EMPLOYMENT_TYPE_OPTIONS, STATUS_OPTIONS, type FilterOption, type LifecycleStatus, type TimelineFilters } from './timelineFilters';

export function TimelineFilterBar({
  filters,
  onChange,
  roleOptions,
}: {
  filters: TimelineFilters;
  onChange: (next: TimelineFilters) => void;
  /** [role, count] pairs already scoped to the active tab — see `rolesInScope`. */
  roleOptions: FilterOption[];
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <MultiSelect
        label="Employment type"
        options={EMPLOYMENT_TYPE_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
        selected={filters.employmentTypes}
        onChange={(next) => onChange({ ...filters, employmentTypes: next as Set<EmploymentType> })}
      />
      <MultiSelect
        label="Status"
        options={STATUS_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
        selected={filters.statuses}
        onChange={(next) => onChange({ ...filters, statuses: next as Set<LifecycleStatus> })}
      />
      <MultiSelect
        label="Role"
        options={roleOptions.map(([role, count]) => ({ value: role, label: `${role} (${count})` }))}
        selected={filters.roles}
        onChange={(next) => onChange({ ...filters, roles: next })}
        allLabel="All roles"
      />
    </div>
  );
}
